import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Input, Modal, Form, InputNumber, message } from 'antd';
import { shipmentApi, type ShipmentDTO } from '../api/kfc';

const Handover: React.FC = () => {
  const [list, setList] = useState<ShipmentDTO[]>([]);
  const [loading, setLoading] = useState(false);
  const [handoverModal, setHandoverModal] = useState<ShipmentDTO | null>(null);
  const [form] = Form.useForm();

  const load = () => {
    setLoading(true);
    shipmentApi.list({ status: 'PENDING_HANDOVER', page: 0, size: 50 })
      .then((res: { data: { content: ShipmentDTO[] } }) => setList(res.data.content || []))
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const submitHandover = () => {
    const s = handoverModal!;
    form.validateFields().then((values) => {
      shipmentApi.handoverConfirm({
        shipmentId: s.shipmentId,
        pendingWeight: values.pendingWeight,
        handoverProofJson: values.handoverProofJson,
        deliveryTrackingNo: values.deliveryTrackingNo,
      }).then(() => {
        message.success('交货信息已提交，待销售确认重量');
        setHandoverModal(null);
        form.resetFields();
        load();
      }).catch((e) => message.error(e.response?.data?.message || '提交失败'));
    });
  };

  return (
    <>
      <Card title="待交货运单 - 操作员回填重量与凭证">
        <Table
          loading={loading}
          dataSource={list}
          rowKey="shipmentId"
          columns={[
            { title: '运单号', dataIndex: 'shipmentId', width: 200 },
            { title: '客户', dataIndex: 'clientCode', width: 100 },
            { title: '线路', dataIndex: 'routeName', width: 120 },
            {
              title: '操作',
              width: 120,
              render: (_, r: ShipmentDTO) => (
                <Button type="primary" size="small" onClick={() => { setHandoverModal(r); form.setFieldsValue({ pendingWeight: r.confirmedWeight }); }}>交货回填</Button>
              ),
            },
          ]}
          pagination={{ pageSize: 10 }}
        />
      </Card>
      <Modal title="交货回填" open={!!handoverModal} onOk={submitHandover} onCancel={() => { setHandoverModal(null); form.resetFields(); }} width={480}>
        {handoverModal && (
          <Form form={form} layout="vertical">
            <Form.Item label="运单号">{handoverModal.shipmentId}</Form.Item>
            <Form.Item name="pendingWeight" label="代理实收重量(kg)">
              <InputNumber min={0} step={0.1} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item name="deliveryTrackingNo" label="货拉拉单号">
              <Input />
            </Form.Item>
            <Form.Item name="handoverProofJson" label="已交货截图/凭证(JSON路径)">
              <Input placeholder='{"screenshot":"path"}' />
            </Form.Item>
          </Form>
        )}
      </Modal>
    </>
  );
};

export default Handover;
